export default __webpack_public_path__ + "static/media/Thug's Tunic of Waning Dusk.efaba1cc.jpg";